import React from "react";
import { Link } from "react-router-dom";
import styles from './not-found.module.css'

const NotFound = () => {
  return (
    <div className={styles["not-found"]}>
      <h2>اوووه...! </h2>
      <p>
        صفحه مورد نظر شما پیدا نشد <Link to={"/"}>صفحه اصلی</Link>
      </p>
    </div>
  );
};

export default NotFound;
